import { useEffect } from 'react';

export function useTelegramBackButton(onBack: () => void, enabled = true) {
  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (!tg || !enabled) return;

    tg.BackButton.show();
    tg.BackButton.onClick(onBack);

    return () => {
      tg.BackButton.offClick(onBack);
      tg.BackButton.hide();
    };
  }, [onBack, enabled]);
}
